module.exports = {
  workingCopyPath: 'Path',
  workingCopyState: 'State',
  workingCopyStaged: 'Staged',
  workingCopyCleanTreeHint: 'Working tree is clean.',
  workingCopyParserFallbackHint: 'Could not parse status output - showing raw output below.',
  fileStateModified: 'Modified',
  fileStateAdded: 'Added',
  fileStateDeleted: 'Deleted',
  fileStateRenamed: 'Renamed',
  fileStateUntracked: 'Untracked',
  fileStateConflicted: 'Conflicted',
  workingCopyActions: 'Actions',
  diffEmpty: 'No differences to show.',
  diffFailedNoDetails: 'Diff failed with no details from server.',
  diffLoading: 'Loading diff…',
  historyShowMore: 'Show more',
  historyParserFallbackHint: 'Could not parse log output - showing raw output below.',
  historyShowMoreParseFailed: 'Could not parse expanded history.',
  filesTabModifiedBadge: 'Modified'
}
